<template>
  <div class="business-stage-div">
    <el-row :gutter="15" class="business-stage">
      <el-col :xs="12" :md="6" :lg="4" v-for="(stage,index) in stageList" :key="stage.stageCode">
        <el-button class="stage-button-wrap" :type="getButtonType(stage)">{{stage.stageDesc}} {{stage.percentage}}</el-button>
        <el-checkbox-group v-model="stage.selectedItemList">
          <div style="position:relative;" v-for="item in stage.itemList">
            <el-checkbox :key="item.id" :label="item" :disabled="item.disabled" style="margin-top: 8px">
              <span>{{item.itemName}}</span>
              <!-- 选中联系人 -->
              <div v-if="item.completeInfo && item.completeInfo.contactList && stage.selectedItemList.indexOf(item) > -1" class="tag-box">
                <el-tag
                  v-for="contact in item.completeInfo.contactList"
                  class="mr5 mt5"
                  :key="contact.contactId"
                  type="info"
                  size="mini">
                  {{contact.contactName}}
                </el-tag>
              </div>
              <!-- 添加合同 -->
              <div v-if="item.completeInfo && item.completeInfo.contractList && stage.selectedItemList.indexOf(item) > -1" class="tag-box">
                <el-tag
                  v-for="contract in item.completeInfo.contractList"
                  class="mr5 mt5"
                  :key="contract.contractId"
                  type="info"
                  size="mini">
                  {{contract.contractNum}}({{contract.contractStatusDesc}})
                </el-tag>
              </div>

              <div class="mt5" v-if="item.type === 'input' && stage.selectedItemList.indexOf(item) > -1"><el-input v-model="item.completeInfo && item.completeInfo.confirmAmount" type="number" placeholder="请输入" style="width:100%;" :disabled="index != currentStageIndex" min="0" max=''></el-input></div>
              <div class="mt5" v-if="(item.type === 'textarea' || item.type === 'both') && stage.selectedItemList.indexOf(item) > -1"><el-input v-model="item.completeInfo && item.completeInfo.content" type="textarea" placeholder="请输入" style="width:100%;" :disabled="index != currentStageIndex" maxlength="500"></el-input></div>
              <div class="mt5" v-if="item.type === 'date' && stage.selectedItemList.indexOf(item) > -1">
                <el-date-picker
                  v-model="item.completeInfo && item.completeInfo.realDealDate"
                  type="date"
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd"
                  :disabled="index != currentStageIndex || stage.completeFlag"
                  style="width:100%;">
                </el-date-picker>
              </div>
            </el-checkbox>
            <!-- 招标文件 -->
            <FileUpload class="mt5 m20" v-if="item.type === 'both' && stage.selectedItemList.indexOf(item) > -1" v-model="item.completeInfo.fileObjs" :limit="9" :readOnly="!stage.isCurrent"
                        ></FileUpload>
            <!-- 添加联系人（放到el-checkbox中点击会触发选中事件） -->
            <el-link class="ml0 add-contact" type="primary" v-if="item.type === 'contact' && stage.selectedItemList.indexOf(item) > -1" :disabled="index != currentStageIndex" @click="handleAddBusinessContact(item)">添加</el-link>
            <el-link class="ml0 add-contact" type="primary" v-if="item.type === 'contract' && stage.selectedItemList.indexOf(item) > -1" :disabled="index != currentStageIndex || stage.completeFlag" @click="handleAddBusinessContract">添加</el-link>
          </div>
        </el-checkbox-group>
        <!-- 无需招标 -->
        <span class="un-bid" v-if="stage.stageCode === 'bidding' && stage.itemList.length === 0">无需招标</span>
      </el-col>
    </el-row>
    <el-row style="margin-top: 20px" class="business-stage-btn">
      <el-col :offset="9">
        <!--商机状态 0-转化中 1-输单 2-已成交 3-无效 4-挂起-->
        <el-button type="primary" v-if="detail.businessStatus === 0" @click="saveCompleteStageItems">保存</el-button>
        <el-button type="info" v-if="detail.businessStatus === 0 && updateData.currentStageCode !== 'confirm_requirements'" @click="changeStage(2)">回退</el-button>
        <el-button type="primary" v-if="detail.businessStatus === 0 && updateData.currentStageCode === 'bidding'" @click="inviteBids ">无需招标</el-button>
        <el-button type="primary" v-if="detail.businessStatus === 0 && updateData.currentStageCode !== 'contract'" @click="changeStage(1)">流转</el-button>
        <el-button type="primary" v-if="detail.businessStatus === 0 && updateData.currentStageCode === 'contract' && !detail.realDealDate" @click="changeStage(3)">成交</el-button>
      </el-col>
    </el-row>
    <AddContractDialog ref="addContractDialogRef" @success="refreshContractAndLog"></AddContractDialog>
    <AddBusinessContactDialog ref="addBusinessContactDialogRef" @success="refreshContactAndLog"></AddBusinessContactDialog>
  </div>
</template>

<script>

import {changeBusinessStage, saveCompleteStageItems} from "@/api/crm/business";
import FileUpload from "@/views/crm/components/fileUpload";
import ChooseContactDialog from "@/views/crm/business/chooseContactDialog"; // 选择联系人
import AddContractDialog from "@/views/crm/contract/addContractDialog";
import AddBusinessContactDialog from "@/views/crm/business/addBusinessContactDialog";
import {checkPermi} from "@/utils/permission";

export default {
  name: "BusinessStage",
  props: {
    detail: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      businessStageNoNeedContractAuth: false,
      stageList: [],
      currentStage: {},
      currentItem: {}, // 当前操作
      updateData: {
        id: null,
        currentStageCode: null
      },
      winFormModel: {
        dealDate: ''
      },
      beforeDateOption: {
        disabledDate (date) {
          return date.getTime() >= Date.now();
        }
      },
      currentStageIndex: null, // 当前阶段
    };
  },
  created() {
    this.businessStageNoNeedContractAuth = checkPermi(['business:stage:noNeedContract'])
    this.init(this.detail);
  },
  components: {
    FileUpload,
    AddBusinessContactDialog,
    AddContractDialog,
    ChooseContactDialog
  },
  watch: {
    detail (detail) {
      this.init(detail);
    },
  },
  methods: {
    init(detail) {
      if (detail && detail.id && detail.businessStageDetailListVos && detail.businessStageDetailListVos.length > 0) {
        this.updateData.id = detail.id;
        this.updateData.currentStageCode = detail.currentStageCode;
        this.stageList = detail.businessStageDetailListVos;
      } else {
        return;
      }
      this.currentStageIndex = this.stageList.findIndex(item => item.stageCode === this.updateData.currentStageCode);

      this.stageList.forEach((stage, index) => {
        this.$set(stage, 'selectedItemList', [])
        stage.itemList.forEach(item => {
          this.$set(item, 'disabled', true)
          if (item.required === 1 && item.itemName.indexOf('必清项') < 0) {
            item.itemName = item.itemName + '(必清项)'
          }
          // 确认金额添加元单位
          if(item.id === 12){
            item.itemName = item.itemName + '(元)'
          }
          if (item.completeFlag || item.required === 1) {
            stage.selectedItemList.push(item)
          }
          // 商机状态 0-转化中 1-输单 2-已成交 3-无效 4-挂起
          if(this.detail.businessStatus === 0 && index === this.currentStageIndex){
            item.disabled = false
          }
          // 必清项
          if(item.required === 1){
            item.disabled = true
          }
          // 有输入框的
          if(item.id === 1 || item.id === 13 || item.id === 14) {
            item.type = 'textarea'
            this.$set(item, 'completeInfo', {
              content: item.completeInfo ? item.completeInfo.content : ''
            })
          }
          //有金额输入框的
          if(item.id === 12){
            item.type = 'input'
            // this.$set(item, 'completeInfo', {
            //   confirmAmount: null
            // })
          }
          // 关联联系人的
          if(item.id === 5 || item.id === 6 || item.id === 8){
            item.type = 'contact'
            // this.$set(item, 'contactList', []) // completeInfo
            // this.$set(item, 'completeInfo', null)
          }
          // 有合同关联的
          if(item.id === 19){
            item.type = 'contract'
            // this.$set(item, 'completeInfo', {
            //   contractList: null
            // })
          }
          // 有日期的
          if(item.id === 20){
            item.type = 'date'
            // this.$set(item, 'completeInfo', {
            //   realDealDate: null
            // })
          }
          // 有文字输入框和文件上传的
          if(item.id === 15){
            item.type = 'both'
            // this.$set(item, 'completeInfo', {
            //   content: null,
            //   fileObjs: []
            // })
          }

        })
        if (index === this.currentStageIndex) {
          this.currentStage = stage
        }
      })
    },
    getButtonType(stage) {
      // 当前阶段展示绿色，已完成的展示蓝色，未到达的展示灰色 商机状态 0-转化中 1-输单 2-已成交 3-无效 4-挂起
      if (stage.completeFlag) {
        return "primary";
      } else if (stage.isCurrent) {
        return "success";
      } else {
        return "info";
      }
    },
    saveCompleteStageItems () {
      // 校验是否没选选择任何任务项
      // if (this.currentStage.selectedItemList.length <= 0) {
      //   this.msgError('请至少完成一个任务项');
      //   return
      // }
      this.$confirm('确认保存吗？', '提示', {confirmButtonText: '确认'}).then(() => {
        let param = {
          businessId: this.updateData.id,
          stageCode: this.updateData.currentStageCode,
          completeItemList: this.convertCompleteItemListParam()
        }
        const loading = this.$loading({lock: true, text: '加载中', spinner: 'el-icon-loading'});
        saveCompleteStageItems(param).then(response => {
          this.msgSuccess("保存成功");
        }).finally(() => {
          loading.close()
        })
      }).catch(() => {});
    },
    changeStage(changeType) {
      // 变更方式 1-流转 2-回退 3-成交
      let tips = ''
      if (changeType === 1) {
        tips = '确认进入下个阶段吗？'
      } else if (changeType === 2) {
        tips = '返回上个阶段，本阶段已完成的任务项将被清除，确认吗？'
      } else if (changeType === 3) {
        tips = '请确认商机是否成交'
      } else {
        return
      }
      // 校验是否没选选择任何任务项，是否必清项已选择
      if (changeType === 1 || changeType === 3) {
        if (changeType === 3) {
          let isPass = true
          if (!isPass) {
            return;
          }
        }
        let checkResult = this.checkStageItem(changeType)
        if (!checkResult) {
          return;
        }
      }
      let param = {
        id: this.updateData.id,
        changeType: changeType,
        completeItemList: this.convertCompleteItemListParam(),
        dealDate: this.winFormModel.dealDate
      }
      this.$confirm(tips, '提示', {confirmButtonText: '确认'}).then(() => {
        this.callChangeBusinessStage(param)
      }).catch(() => {
      });
    },
    convertCompleteItemListParam(){
      let completeItemList = []
      this.currentStage.selectedItemList.forEach(item => {
        let completeInfo = null
        if (item.itemName === '关键人1W(必清项)' || item.itemName === '确认C'
          || item.itemName === '决策人3F' || item.itemName === '合同审批(必清项)') {
          completeInfo = null
        } else {
          completeInfo = JSON.stringify(item.completeInfo)
        }
        completeItemList.push({id: item.id, completeInfo: completeInfo})
      })
      return completeItemList
    },
    callChangeBusinessStage (param) {
      const loading = this.$loading({lock: true, text: '加载中', spinner: 'el-icon-loading'});
      changeBusinessStage(param).then(response => {
        this.$emit('stage-change')
        this.msgSuccess("操作成功");
      }).finally(() => {
        loading.close()
      })
    },
    checkStageItem () {
      // if (this.currentStage.selectedItemList.length <= 0) {
      //   this.msgError('请至少完成一个任务项');
      //   return false
      // }
      let isPass = true
      this.currentStage.itemList.find(item => {
        // 校验必清项是否已选择
        if (item.required === 1) {
          if(item.type === 'textarea' && !item.completeInfo.content){
            this.msgError('有[必清项]没有完成');
            isPass = false
            return true
          }else if(item.type === 'input' && !item.completeInfo.confirmAmount) {
            this.msgError('有[必清项]没有完成');
            isPass = false
            return true
          }
          // else if(item.type === 'contact' && item.contactList.length <= 0) {
          //   this.msgError('有[必清项]没有完成');
          //   isPass = false
          //   return true
          // }
          else if(item.type === 'both' && !item.completeInfo.content) {
            this.msgError('有[必清项]没有完成');
            isPass = false
            return true
          }
          // 可配置不检验合同的角色
          else if (!this.businessStageNoNeedContractAuth && item.type === 'date' && !item.completeInfo.realDealDate) {
            this.msgError('有[必清项]没有完成');
            isPass = false
            return true
          } else if (!this.businessStageNoNeedContractAuth && item.type === 'contract' && item.completeInfo.contractList.length <= 0) {
            this.msgError('有[必清项]没有完成');
            isPass = false
            return true
          }
        }
      })
      // this.init(this.detail); // 报错后数据绑定会失效，重置数据绑定
      return isPass
    },
    handleFileChange (fileObjs) {
      this.queryParams.attachmentFileIdList = fileObjs;
    },
    addContact(item ){
      this.currentItem = item
      this.$refs.chooseContactDialogRef.open(this.detail.id)
    },
    inviteBids(){
      let that = this
      that.$confirm('请确认商机是否无需招标并流转至下一阶段', '提示', {confirmButtonText: '确认'}).then(() => {
        let param = {
          changeType: 1,
          id: that.detail.id,
          completeItemList: [{id: -1}]
        }
        const loading = that.$loading({lock: true, text: '加载中', spinner: 'el-icon-loading'});
        changeBusinessStage(param).then(response => {
          that.$emit('stage-change')
          that.msgSuccess("操作成功");
        }).finally(() => {
          loading.close()
        })
      }).catch(() => {});
    },
    /** 新增按钮操作 */
    handleAddBusinessContact(row) {
      let role = null
      if(row.itemName === '关键人1W(必清项)'){
        role = '1W'
      }else if(row.itemName === '确认C'){
        role = 'C'
      }else if(row.itemName === '决策人3F'){
        role = '3F'
      }
      this.$refs.addBusinessContactDialogRef.open(this.detail.id, null, role);
    },
    /** 新增合同按钮操作 */
    handleAddBusinessContract() {
      this.$refs.addContractDialogRef.open('businessId', this.detail.id, this.detail.businessName, this.detail.customerId, this.detail.customerName, this.detail.managerId);
    },
    refreshContactAndLog() {
      this.$emit('stage-change') // 新增联系人成功后刷新页面
    },
    refreshContractAndLog(){
      this.$emit('stage-change') // 新增合同成功后刷新页面
    }
  }
};
</script>

<style lang='scss' scoped>
::v-deep .el-checkbox__input.is-disabled + span.el-checkbox__label{
  color: #666
}
// .el-tag--info{
  // word-break: break-word;
  // overflow: hidden;
  // max-width: 200px;
  // text-overflow: ellipsis;
// }
.un-bid{
  color: #C0C4CC;
  font-size: 14px;
  padding-top: 8px;
  display: inline-block;
}
.tag-box{
  width: 150px;
  display: flex;
  flex-wrap: wrap;
}
.add-contact{
  position: absolute;
  top: 10px;
  right: 0;
}
::v-deep .upload-files{
  .image{
    width: 60px;
    height: 60px;
  }
}
::v-deep .upload-files{
  .el-upload-list__item{
    height: 60px;
    width: 60px;
  }
  .el-upload--picture-card{
    height: 60px;
    width: 60px;
    line-height: 60px;
    i{
      font-size: 10px;
    }
  }
}
::v-deep .el-checkbox__input{
  position: absolute;
  padding-top: 3px;
}
::v-deep .el-checkbox__label{
  padding-left: 20px;
}
  .business-stage-div {
    .business-stage {
      .stage-button-wrap {
        width: 100%;
        border-bottom-right-radius: 50px;
        border-top-right-radius: 50px;
      }

      .el-button {
        cursor: default;
      }
    }

    .business-stage-btn {
      .el-button--primary {
        background-color: #07aae2;
        border-color: #07aae2;
      }

      .el-button--primary:hover {
        background-color: #06bdf9;
        border-color: #06bdf9;
      }
    }

    .winTips {
      margin-bottom: 30px;
    }
  }
</style>
